import { LeftArrowIcon, RightArrowIcon } from '@sketchnote/icons';
import RCPagination, { PaginationProps as RCPaginationProps } from 'rc-pagination';
import * as React from 'react';

import styles from './style.module.css';

export type PaginationProps = RCPaginationProps;

export const Pagination = (otherProps: RCPaginationProps) => {
  const [current, setCurrent] = React.useState(3);
  const onChange = (page) => {
    setCurrent(page);
  };
  return (
    <RCPagination
      onChange={onChange}
      current={current}
      total={otherProps.total}
      prevIcon={<LeftArrowIcon />}
      nextIcon={<RightArrowIcon />}
      className={styles.sn__pagination}
      {...otherProps}
    />
  );
};
